import React, { Component } from 'react'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import CompanyApi from '../services/company.service'

type IState = {
    companyList: any;
    selectedItem: any;
}
const apiservices = new CompanyApi();

export type SelectCompanyProps = {
    optionHandler?: any
}

class SelectCompany extends Component<SelectCompanyProps, IState>{
    constructor(props: any) {
        super(props);
        this.state = {
            companyList: [],
            selectedItem: null
        };
    }


    async componentDidMount() {
        const response = await apiservices.getCompanies();
        var comp: any = [];
        response.map((company: any) => {
            comp.push({
                'title': `${company.name} (${company.id})`,
                'value': company.id
            })
            if(company.id === 3){
                this.setState({    
                    selectedItem: {
                        'title': `${company.name} (${company.id})`,
                        'value': company.id,
                    }
                })
            }
    });
        var resultArray = Object.keys(comp).map(function (compIndex) {
            let company = comp[compIndex];
            return company;
        });
        this.setState({
            companyList: resultArray,
        })
        await this.onCompanySelect('', this.state.selectedItem)  
    }

    async onCompanySelect(e: any, value: any) {
        if (value) {
            const supportUser: any = await apiservices.getSupportUserForCompany(value.value) || {};

            await localStorage.setItem(
                'selectedCompanyDisplay', value.title
            );
            await localStorage.setItem(
                'selectedCompanyId', value.value
            );
            await localStorage.setItem(
                'supportUserIdOfSelectedCompany', supportUser.id
            );
            await localStorage.setItem(
                'SupportUserDetailsOfSelectedCompany', supportUser
            );
            const googleTokenId = localStorage.getItem("google-token");
            const selectedCompanyId = localStorage.getItem("selectedCompanyId");
            const params = {
                googleTokenId: googleTokenId,
                selectedCompanyId: selectedCompanyId,
                supportUserId: supportUser.id
            }
            const response = await apiservices.auth(params);
            await localStorage.setItem(
                'access-token', response.accessToken
            );
            await localStorage.setItem(
                'company-id', value.value
            );
            await localStorage.setItem(
                'user-id', supportUser.id
            );
            this.setState({
                selectedItem: {
                    'title': value.title,
                    'value': value.value
                }
            }, () => {
                value = this.state.selectedItem
            })
            if (this.props.optionHandler) {
                this.props.optionHandler({
                    'title': value.title,
                    'value': value.value
                })
            }
        }
    }
    

    render() {
        
        return (
                <Autocomplete
                    id="combo-box-demo"
                    options={this.state.companyList}
                    getOptionLabel={
                        (option: any) => option.title
                    }
                    getOptionSelected={
                        (option, value) => option.title === value.title
                    }
                    onChange={(e, value) => {
                        this.onCompanySelect(e, value)
                    }}
                    value={this.state.selectedItem}
                    renderInput={(params) =>
                        <TextField {...params}
                            placeholder="Select Company"
                            variant="outlined" />}
                />
        )
    }
}

export default SelectCompany;